import * as Yup from 'yup'

export interface ICreateAccount {
  accountType: string
  accountTeamSize: string
  accountName: string
  accountPlan: string
  businessName: string
  businessDescriptor: string
  businessType: string
  businessDescription: string
  businessEmail: string
  nameOnCard: string
  cardNumber: string
  cardExpiryMonth: string
  cardExpiryYear: string
  cardCvv: string
  saveCard: string
}

const createAccountSchemas = [
  Yup.object({
    accountType: Yup.string().label('Account Type'),
  }),
  Yup.object({
    accountName: Yup.string().label('Account Name'),
  }),
  Yup.object({
    businessName: Yup.string().label('Business Name'),
    businessDescriptor: Yup.string().label('Shortened Descriptor'),
    businessType: Yup.string().label('Corporation Type'),
    businessEmail: Yup.string().label('Contact Email'),
  }),
  Yup.object({
    nameOnCard: Yup.string().label('Name On Card'),
    cardNumber: Yup.string().label('Card Number'),
    cardExpiryMonth: Yup.string().label('Expiration Month'),
    cardExpiryYear: Yup.string().label('Expiration Year'),
    cardCvv: Yup.string().label('CVV'),
  }),
]

const inits: ICreateAccount = {
  accountType: 'personal',
  accountTeamSize: '50+',
  accountName: '',
  accountPlan: '1',
  businessName: 'Keenthemes Inc.',
  businessDescriptor: 'KEENTHEMES',
  businessType: '1',
  businessDescription: '',
  businessEmail: 'corp@support.com',
  nameOnCard: 'Max Doe',
  cardNumber: '4111 1111 1111 1111',
  cardExpiryMonth: '1',
  cardExpiryYear: '2025',
  cardCvv: '123',
  saveCard: '1',
}

export {createAccountSchemas, inits}
